/*!
 * Tooltip Class Definition
 * extends OverlayView:
 * https://developers.google.com/maps/documentation/javascript/reference#OverlayView
 *
 * style over .gmOverTooltipWindow class:
 * <style>
 *		.gmOverTooltipWindow {
 *			position:absolute;
 *			font-size:12px;
 *			color:#656565;
 *			font-family: arial;
 *			font-weight: bold;
 *			background: #ffffff;
 *			padding: 4px 8px;
 *			border-radius: 6px;
 *			border: #9fc53b 3px solid;
 *			white-space: nowrap;
 *			box-shadow: rgba(0,0,0,.3) 0 1px 3px;
 *		}
 *	</style>
 */
var $ = require('jquery');

var GMCustomTooltip;
GMCustomTooltip = function(settings) {
	this.buildDOM(settings);
};

$.extend(GMCustomTooltip.prototype, google.maps.OverlayView.prototype, {
	// build the DOM
	buildDOM: function(s) {
		// Window DIV
		this.wdiv = $("<div></div>").addClass('gmOverTooltipWindow ' + s.appClassName);
		// Start Closed
		this.close();
	},

	// API - onAdd
	onAdd: function() {
		$(this.getPanes().floatPane).append(this.wdiv);
	},

	// API - onRemove
	onRemove: function() {
		this.wdiv.detach();
	},

	// API - draw
	draw: function() {
		var pos, left, top;
		// projection is accessible?
		if (!this.getProjection()) return;
		// position is accessible?
		if (!this.get('position')) return;
		// convert projection
		pos = this.getProjection().fromLatLngToDivPixel(this.get('position'));
		// top offset
		top = pos.y - this.getAnchorHeight() / 2 - this.wdiv.outerHeight()/2;
		// left offset
		if (this.getMap().getCenter().lng() > this.get('position').lng()) {
			left = pos.x + this.wdiv.outerWidth() * 0.3;
		} else {
			left = pos.x - this.wdiv.outerWidth() * 1.3;
		}
		// window position
		this.wdiv.css('top', top);
		this.wdiv.css('left', left);
	},

	// open Tooltip
	open: function(map, anchor, title) {
		// bind to map
		if (map) this.setMap(map);
		// bind to anchor
		if (anchor) {
			this.set('anchor', anchor);
			this.bindTo('anchorPoint', anchor);
			this.bindTo('position', anchor);
		}
		// need to force redraw otherwise it will decide to draw after we show the Tooltip
		this.draw();
		// set text tooltip
		this.wdiv.text(title);
		// show tooltip
		this.wdiv.show();
		// set property
		this.isOpen = true;
	},

	// close Tooltip
	close: function() {
		// hide tooltip
		this.wdiv.hide();
		// set property
		this.isOpen = false;
	},

	// correctly get the anchorPoint height
	getAnchorHeight: function() {
		// See: https://developers.google.com/maps/documentation/javascript/reference#InfoWindow
		//   "The anchorPoint is the offset from the anchor's position to the tip of the InfoWindow."
		return -1 * this.get('anchorPoint').y;
	}
});

window.GMCustomTooltip = GMCustomTooltip;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/googlemaps-tooltip.js